import React, { useContext } from 'react';

import classNames from 'classnames';

import { PageLayout } from '../../../types';
import { PageContext } from '../../context/PageContext';
import { DocsMenu } from '../DocsMenu';
import { Navigation } from '../Navigation';
import { NavigationControls } from '../NavigationControls';
import { PlatformMenu } from '../PlatformMenu';
import { Search } from '../Search';
import { VersionMenu } from '../VersionMenu';

import { Content } from './Content';
import * as classes from './style.module.scss';
import { Title } from './Title';

interface Props {
  pathname: string;
  siteName: string;
}

export const DocumentationNavigation: React.FC<Props> = ({
  pathname,
  siteName,
}) => {
  const { platforms, layout } = useContext(PageContext);

  return (
    <Navigation
      className={classNames({ [classes.basic]: layout === PageLayout.Basic })}
    >
      {(layout === PageLayout.Documentation ||
        layout === PageLayout.InteractiveCode) && (
        <>
          <Title />
          <NavigationControls>
            {platforms ? (
              <>
                <DocsMenu />
                <div className={classes.menu}>
                  <PlatformMenu />
                  <VersionMenu />
                </div>
              </>
            ) : (
              <div className={classes.menu}>
                <DocsMenu short />
                {!platforms && <VersionMenu />}
              </div>
            )}
          </NavigationControls>
        </>
      )}
      {layout !== PageLayout.Basic && (
        <>
          <Search className={classes.search} siteName={siteName} />
          <Content pathname={pathname} />
        </>
      )}
    </Navigation>
  );
};
